import React from 'react';
import { CSpinner } from '@coreui/react';

import './LoadingOverlay.scss';

const LoadingOverlay = () => {
  return (
    <div className="layout-overlay backdrop" >
      <div className="spinner-container">
        <CSpinner grow size="lg" className="primary-color"/>
      </div>
    </div>
  );
};

export default LoadingOverlay;